(function () {
    /**
     * @module basicSearch
     */

    var basicSearch = {};
    var facetNavigationPending = false;
    var facetFiltersInitialised = false;

    /**
     * Init the basicSearch component by adding relevent event listeners
     *
     * @memberof module:basicSearch
     */

    basicSearch.init = function () {
        var searchForm = document.querySelector(
            ".qld__banner__search .qld__search-form"
        );
        if (searchForm) {
            searchForm
                .querySelector(".qld__btn--search")
                .setAttribute("type", "submit");
            searchForm
                .querySelectorAll(".qld__btn--search, .qld__text-input")
                .forEach((el) => {
                    el.removeAttribute("disabled");
                });
            initBannerSearchForm(searchForm);
        }

        if (document.querySelector(".qld__search__sort #search-sort")) {
            var selectElement = document.getElementById("search-sort");
            var currentUrl = new URL(window.location.href);
            var searchParams = new URLSearchParams(currentUrl.search);

            var sortParam = searchParams.get("sort");
            // True if searchSorting #908423 set to custom and false if set to default
            var isCustomSorting = window.globals?.current?.data?.metadata?.searchSorting?.value === 'custom';

            // On some pages like practice-directions we only expose date sorting options
            // (labels include range direction).
            if (isCustomSorting) {
                // Remove existing options (Relevance + A-Z/Z-A/Newest/Oldest).
                while (selectElement.firstChild) {
                    selectElement.removeChild(selectElement.firstChild);
                }

                var relevanceOption = document.createElement("option");
                relevanceOption.value = "relevance";
                relevanceOption.textContent = "Relevance";
                selectElement.appendChild(relevanceOption);

                var newestToOldestOption = document.createElement("option");
                newestToOldestOption.value = "dmetat";
                newestToOldestOption.textContent = "Newest to Oldest";
                selectElement.appendChild(newestToOldestOption);

                var oldestToNewestOption = document.createElement("option");
                oldestToNewestOption.value = "metat";
                oldestToNewestOption.textContent = "Oldest to Newest";
                selectElement.appendChild(oldestToNewestOption);

                // // Preserve selection if we were given a legacy sort param.
                // if (sortParam === "metat") {
                //     sortParam = "date";
                // } else if (sortParam === "dmetat") {
                //     sortParam = "adate";
                // }

                // Default to "Newest to Oldest" when `sort` is missing/empty.
                if (!searchParams.has("sort") || !sortParam) {
                    sortParam = "dmetat";
                }

                selectElement.value = selectParamToExistingValue(
                    selectElement,
                    sortParam
                );
            }

            if (!isCustomSorting && searchParams.has("sort")) {
                // Fallback to relevance if provided value isn't among visible options.
                selectElement.value = selectParamToExistingValue(
                    selectElement,
                    sortParam
                );
            }

            selectElement.addEventListener("change", function () {
                var selectedValue = this.value;
                var nextUrl = new URL(window.location.href);

                nextUrl.search = cleanFunnelbackSearchParams(nextUrl.search);
                nextUrl.searchParams.set("sort", selectedValue);
                window.location.href = nextUrl.toString();
            });
        }

        // Initialize filters accordion
        initFiltersAccordion();

        // Initialize filter checkboxes
        initFilterCheckboxes();

        // Fix Funnelback links that HTML-encode quotes in query params.
        initSearchUrlSanitization();
        fixPadreNullParamsOnCurrentPage();
        sanitizeSearchLinksOnPage();
    };

    /**
     * Initialize the filters accordion functionality
     *
     * @memberof module:basicSearch
     * @instance
     * @private
     */
    function initFiltersAccordion() {
        var accordionHeaders = document.querySelectorAll(
            ".qld__search__filters-accordion-header"
        );

        accordionHeaders.forEach(function (header) {
            header.addEventListener("click", function () {
                var content = document.getElementById(
                    this.getAttribute("aria-controls")
                );
                var isExpanded = this.getAttribute("aria-expanded") === "true";

                // Toggle accordion state
                if (isExpanded) {
                    // Currently open, so close it
                    this.setAttribute("aria-expanded", "false");
                    this.classList.remove("qld__accordion--open");
                    this.classList.add("qld__accordion--closed");
                    content.classList.remove("qld__accordion--open");
                    // DON'T add qld__accordion--closed class yet - wait for transition

                    // Animate height to 0
                    var currentHeight = content.scrollHeight;
                    content.style.height = currentHeight + "px";
                    // Force reflow
                    content.offsetHeight;
                    // Ensure transition is applied
                    content.style.transition = "height 0.25s ease-in";
                    // Small delay to ensure transition is registered
                    setTimeout(function () {
                        content.style.height = "0px";
                        // Add the closed class after transition completes
                        setTimeout(function () {
                            content.classList.add("qld__accordion--closed");
                        }, 250);
                    }, 10);
                } else {
                    // Currently closed, so open it
                    this.setAttribute("aria-expanded", "true");
                    this.classList.remove("qld__accordion--closed");
                    this.classList.add("qld__accordion--open");
                    content.classList.remove("qld__accordion--closed");
                    content.classList.add("qld__accordion--open");

                    // Animate height from 0 to auto
                    content.style.height = "0px";
                    // Force reflow
                    content.offsetHeight;
                    // Now animate to full height
                    content.style.height = content.scrollHeight + "px";
                }

                // Debug: log the current state
                console.log(
                    "Accordion clicked - aria-expanded:",
                    this.getAttribute("aria-expanded"),
                    "classes:",
                    this.className
                );
            });
        });
    }

    /**
     * Initialize filter checkbox functionality
     *
     * @memberof module:basicSearch
     * @instance
     * @private
     */
    function initFilterCheckboxes() {
        var filtersSidebar = document.querySelector(
            ".qld__search__filters-sidebar"
        );

        if (!filtersSidebar || facetFiltersInitialised) {
            return;
        }

        facetFiltersInitialised = true;

        filtersSidebar.addEventListener("change", function (event) {
            var checkbox = event.target;

            if (
                !(checkbox instanceof HTMLInputElement) ||
                checkbox.type !== "checkbox" ||
                !checkbox.closest(".qld__search__filter-checkbox")
            ) {
                return;
            }

            activateFacetFilter(checkbox);
        });
    }

    /**
     * Start facet navigation for a selected filter checkbox.
     *
     * @param {HTMLInputElement} checkbox
     * @private
     */
    function activateFacetFilter(checkbox) {
        if (facetNavigationPending) {
            checkbox.checked = !checkbox.checked;
            return;
        }

        var toggleUrl = checkbox.getAttribute("data-toggle-url");

        if (!toggleUrl) {
            checkbox.checked = !checkbox.checked;
            return;
        }

        lockFacetFilters();
        navigateToFacetUrl(toggleUrl);
    }

    /**
     * Remove duplicate non-facet params from a Funnelback query string.
     *
     * @param {string} queryString
     * @returns {string}
     * @private
     */
    function dedupeFacetQuery(queryString) {
        var raw = queryString.charAt(0) === "?" ? queryString.slice(1) : queryString;

        if (!raw) {
            return "";
        }

        var seenFacetPairs = new Set();
        var seenSingleUseKeys = Object.create(null);
        var parts = [];

        raw.split("&").forEach(function (part) {
            if (!part) {
                return;
            }

            var equalsIndex = part.indexOf("=");
            var encodedKey = equalsIndex >= 0 ? part.slice(0, equalsIndex) : part;
            var decodedKey = decodeURIComponent(
                encodedKey.replace(/\+/g, " ")
            );

            if (decodedKey.indexOf("f.") === 0) {
                if (seenFacetPairs.has(part)) {
                    return;
                }

                seenFacetPairs.add(part);
                parts.push(part);
                return;
            }

            if (seenSingleUseKeys[decodedKey]) {
                return;
            }

            seenSingleUseKeys[decodedKey] = true;
            parts.push(part);
        });

        return parts.join("&");
    }

    /**
     * Build the full facet navigation URL from a Funnelback toggle URL.
     *
     * @param {string} toggleUrl
     * @returns {string}
     * @private
     */
    function buildFacetHref(toggleUrl) {
        if (/^https?:\/\//i.test(toggleUrl)) {
            var absoluteUrl = new URL(toggleUrl);
            absoluteUrl.search = cleanFunnelbackSearchParams(absoluteUrl.search);
            return sanitizeFunnelbackSearchUrl(absoluteUrl.toString());
        }

        var query = toggleUrl.charAt(0) === "?" ? toggleUrl.slice(1) : toggleUrl;

        return sanitizeFunnelbackSearchUrl(
            window.location.origin +
            window.location.pathname +
            "?" +
            cleanFunnelbackSearchParams(query)
        );
    }

    /**
     * Normalize a search query value that may be URL/HTML encoded.
     *
     * @param {string} value
     * @returns {string}
     * @private
     */
    function normalizeSearchQueryValue(value) {
        if (!value) {
            return value;
        }

        var normalized = value;
        var previous;

        do {
            previous = normalized;

            try {
                normalized = decodeURIComponent(
                    normalized.replace(/\+/g, " ")
                );
            } catch (error) {
                // Keep the current value when decoding fails.
            }

            normalized = decodeHtmlEntities(normalized);
        } while (normalized !== previous);

        return normalized;
    }

    /**
     * Decode common HTML entities in search text.
     *
     * @param {string} value
     * @returns {string}
     * @private
     */
    function decodeHtmlEntities(value) {
        if (!value || value.indexOf("&") === -1) {
            return value;
        }

        return value.replace(
            /&(?:quot|#34|#039|amp|lt|gt);/g,
            function (entity) {
                switch (entity) {
                    case "&quot;":
                    case "&#34;":
                        return '"';
                    case "&#039;":
                        return "'";
                    case "&amp;":
                        return "&";
                    case "&lt;":
                        return "<";
                    case "&gt;":
                        return ">";
                    default:
                        return entity;
                }
            }
        );
    }

    /**
     * Fix query params in Funnelback URLs that use HTML-encoded quotes.
     *
     * @param {string} href
     * @returns {string}
     * @private
     */
    function sanitizeFunnelbackSearchUrl(href) {
        if (!href || href.indexOf("query=") === -1) {
            return href;
        }

        var isAbsolute = /^https?:\/\//i.test(href);
        var isQueryOnly = href.charAt(0) === "?";
        var url;

        try {
            url = new URL(
                href,
                window.location.origin + window.location.pathname
            );
        } catch (error) {
            return href
                .replace(/%26quot%3B/gi, "%22")
                .replace(/&quot;/g, "%22")
                .replace(/&#34;/g, "%22")
                .replace(/%26%23(34|039)%3B/gi, "%22");
        }

        var queryValue = url.searchParams.get("query");

        if (queryValue === null) {
            return href;
        }

        var normalizedQuery = normalizeSearchQueryValue(queryValue);

        if (normalizedQuery === queryValue) {
            return href;
        }

        url.searchParams.set("query", normalizedQuery);

        if (isAbsolute) {
            return url.toString();
        }

        if (isQueryOnly) {
            return url.search + url.hash;
        }

        return url.pathname + url.search + url.hash;
    }

    /**
     * Fix the current page URL when the query param was encoded incorrectly.
     *
     * @private
     */
    function fixCurrentPageQueryParam() {
        var url = new URL(window.location.href);
        var queryValue = url.searchParams.get("query");

        if (!queryValue) {
            return;
        }

        var normalizedQuery = normalizeSearchQueryValue(queryValue);

        if (normalizedQuery === queryValue) {
            return;
        }

        url.searchParams.set("query", normalizedQuery);
        window.history.replaceState(
            null,
            "",
            url.pathname + url.search + url.hash
        );
    }

    /**
     * Navigate to a sanitized search URL.
     *
     * @param {string} href
     * @private
     */
    function navigateToSanitizedHref(href) {
        var targetHref = sanitizeFunnelbackSearchUrl(href);

        if (/^https?:\/\//i.test(targetHref)) {
            window.location.href = targetHref;
            return;
        }

        if (targetHref.charAt(0) === "?") {
            window.location.href = window.location.pathname + targetHref;
            return;
        }

        window.location.href = targetHref;
    }

    /**
     * Repair search links and query display when quotes were HTML-encoded.
     *
     * @private
     */
    function initSearchUrlSanitization() {
        var searchRoot = document.querySelector(".qld__search");

        if (!searchRoot) {
            return;
        }

        searchRoot.querySelectorAll("a[href]").forEach(function (link) {
            var href = link.getAttribute("href");
            var sanitizedHref = sanitizeSearchHref(href);

            if (sanitizedHref !== href) {
                link.setAttribute("href", sanitizedHref);
            }
        });

        searchRoot
            .querySelectorAll("[data-toggle-url]")
            .forEach(function (element) {
                var toggleUrl = element.getAttribute("data-toggle-url");
                var sanitizedToggleUrl = sanitizeSearchHref(toggleUrl);

                if (sanitizedToggleUrl !== toggleUrl) {
                    element.setAttribute("data-toggle-url", sanitizedToggleUrl);
                }
            });

        var queryInput = document.getElementById("search-input-global-basic-query");

        if (queryInput) {
            queryInput.value = normalizeSearchQueryValue(queryInput.value);
        }

        fixCurrentPageQueryParam();

        searchRoot.addEventListener("click", function (event) {
            var link = event.target.closest("a[href]");

            if (!link || !link.closest(".qld__search-pagination")) {
                return;
            }

            event.preventDefault();
            navigateToSanitizedHref(link.getAttribute("href"));
        });
    }

    /**
     * Disable all facet controls while a filter request is in progress.
     *
     * @private
     */
    function lockFacetFilters() {
        facetNavigationPending = true;
        setFiltersLoading(true);
        setFacetCheckboxesDisabled(true);
    }

    /**
     * Enable or disable facet checkboxes.
     *
     * @param {boolean} disabled
     * @private
     */
    function setFacetCheckboxesDisabled(disabled) {
        document
            .querySelectorAll(
                '.qld__search__filter-checkbox input[type="checkbox"]'
            )
            .forEach(function (checkbox) {
                checkbox.disabled = disabled;
            });
    }

    /**
     * Block further facet clicks while the page is navigating.
     *
     * @private
     */
    function setFiltersLoading(isLoading) {
        var filtersSidebar = document.querySelector(
            ".qld__search__filters-sidebar"
        );

        if (filtersSidebar) {
            filtersSidebar.classList.toggle(
                "qld__search__filters-sidebar--loading",
                isLoading
            );
            filtersSidebar.setAttribute("aria-busy", isLoading ? "true" : "false");
        }
    }

    /**
     * Navigate to a Funnelback facet toggle URL.
     *
     * @param {string} toggleUrl
     * @private
     */
    function navigateToFacetUrl(toggleUrl) {
        if (!toggleUrl) {
            return;
        }

        window.location.href = buildFacetHref(toggleUrl);
    }

    /**
     * Returns `value` if an option with it exists, otherwise `""` (Relevance).
     * Prevents selecting a non-existing option after we rebuild options for
     * practice-directions.
     */
    function selectParamToExistingValue(selectElement, value) {
        var normalizedValue =
            value === null || value === undefined ? "" : value;
        for (var i = 0; i < selectElement.options.length; i++) {
            if (selectElement.options[i].value === normalizedValue) {
                return normalizedValue;
            }
        }
        return "";
    }

    var PRESERVED_SEARCH_PARAMS = [
        "profile",
        "collection",
        "sort",
        "num_ranks",
        "s",
    ];
    var REMOVED_ON_NEW_SEARCH_PARAMS = ["start_rank", "query"];

    /**
     * Whether a value is Funnelback's Padre null placeholder.
     *
     * @param {string|null|undefined} value
     * @returns {boolean}
     * @private
     */
    function isPadreNullValue(value) {
        if (value === null || value === undefined || value === "") {
            return true;
        }

        var normalized = value;

        try {
            normalized = decodeURIComponent(String(value).replace(/\+/g, " "));
        } catch (error) {
            normalized = String(value);
        }

        normalized = normalized.toLowerCase();

        return (
            normalized === "!padrenull" ||
            normalized === "!fundoesnotexist:padrenull"
        );
    }

    /**
     * Whether the search has a real query (not Padre null).
     *
     * @param {string|null|undefined} query
     * @returns {boolean}
     * @private
     */
    function hasActiveSearchQuery(query) {
        return query && !isPadreNullValue(query);
    }

    /**
     * Decode a query-string value for comparison.
     *
     * @param {string} encodedValue
     * @returns {string}
     * @private
     */
    function decodeQueryParamValue(encodedValue) {
        try {
            return decodeURIComponent(encodedValue.replace(/\+/g, " "));
        } catch (error) {
            return encodedValue;
        }
    }

    /**
     * Remove Padre null `s` params when a real search query is present.
     *
     * @param {string} queryString
     * @returns {string}
     * @private
     */
    function cleanFunnelbackSearchParams(queryString) {
        var raw =
            queryString.charAt(0) === "?" ? queryString.slice(1) : queryString;

        if (!raw) {
            return "";
        }

        var queryValue = null;
        var parts = [];

        raw.split("&").forEach(function (part) {
            if (!part) {
                return;
            }

            var equalsIndex = part.indexOf("=");
            var encodedKey =
                equalsIndex >= 0 ? part.slice(0, equalsIndex) : part;
            var decodedKey = decodeQueryParamKey(encodedKey);
            var decodedValue =
                equalsIndex >= 0
                    ? decodeQueryParamValue(part.slice(equalsIndex + 1))
                    : "";

            if (decodedKey === "query") {
                queryValue = decodedValue;
            }

            if (
                hasActiveSearchQuery(queryValue) &&
                decodedKey === "s" &&
                isPadreNullValue(decodedValue)
            ) {
                return;
            }

            parts.push(part);
        });

        return dedupeFacetQuery(parts.join("&"));
    }

    /**
     * Decode a query-string key for comparison.
     *
     * @param {string} encodedKey
     * @returns {string}
     * @private
     */
    function decodeQueryParamKey(encodedKey) {
        return decodeURIComponent(encodedKey.replace(/\+/g, " "));
    }

    /**
     * Resolve the pathname that banner search submissions should target.
     *
     * @param {string|null} formAction
     * @returns {string}
     * @private
     */
    function resolveSearchFormPath(formAction) {
        if (!formAction) {
            return window.location.pathname;
        }

        try {
            return new URL(formAction, window.location.origin).pathname;
        } catch (error) {
            return formAction.split("?")[0];
        }
    }

    /**
     * Build a search URL that keeps active facet filters and search config.
     *
     * @param {string} newQuery
     * @param {string|null} formAction
     * @returns {string}
     * @private
     */
    function buildSearchUrlPreservingFilters(newQuery, formAction) {
        var rawSearch = window.location.search;
        var queryString =
            rawSearch.charAt(0) === "?" ? rawSearch.slice(1) : rawSearch;
        var facetParts = [];
        var preservedParts = Object.create(null);
        var preservedOrder = [];

        queryString.split("&").forEach(function (part) {
            if (!part) {
                return;
            }

            var equalsIndex = part.indexOf("=");
            var encodedKey =
                equalsIndex >= 0 ? part.slice(0, equalsIndex) : part;
            var decodedKey = decodeQueryParamKey(encodedKey);

            if (REMOVED_ON_NEW_SEARCH_PARAMS.indexOf(decodedKey) >= 0) {
                return;
            }

            if (decodedKey.indexOf("f.") === 0) {
                facetParts.push(part);
                return;
            }

            if (PRESERVED_SEARCH_PARAMS.indexOf(decodedKey) >= 0) {
                if (
                    decodedKey === "s" &&
                    hasActiveSearchQuery(newQuery)
                ) {
                    return;
                }

                if (!preservedParts[decodedKey]) {
                    preservedParts[decodedKey] = part;
                    preservedOrder.push(decodedKey);
                }
            }
        });

        var parts = [];

        preservedOrder.forEach(function (key) {
            parts.push(preservedParts[key]);
        });

        if (newQuery) {
            parts.push(
                "query=" +
                    encodeURIComponent(
                        normalizeSearchQueryValue(newQuery)
                    ).replace(/%20/g, "+")
            );
        }

        parts = parts.concat(facetParts);

        return sanitizeFunnelbackSearchUrl(
            window.location.origin +
                resolveSearchFormPath(formAction) +
                "?" +
                cleanFunnelbackSearchParams(parts.join("&"))
        );
    }

    /**
     * Remove Padre null `s` from the current page URL when a query is active.
     *
     * @private
     */
    function fixPadreNullParamsOnCurrentPage() {
        var url = new URL(window.location.href);
        var queryValue = url.searchParams.get("query");
        var sValue = url.searchParams.get("s");

        if (
            !hasActiveSearchQuery(queryValue) ||
            !sValue ||
            !isPadreNullValue(sValue)
        ) {
            return;
        }

        url.searchParams.delete("s");
        window.history.replaceState(
            null,
            "",
            url.pathname + url.search + url.hash
        );
    }

    /**
     * Clean Funnelback URLs used in search navigation links.
     *
     * @param {string} href
     * @returns {string}
     * @private
     */
    function sanitizeSearchHref(href) {
        if (!href || href.indexOf("?") === -1) {
            return href;
        }

        var isQueryOnly = href.charAt(0) === "?";
        var isAbsolute = /^https?:\/\//i.test(href);
        var url;

        try {
            url = new URL(href, window.location.origin);
        } catch (error) {
            return href;
        }

        var cleanedSearch = cleanFunnelbackSearchParams(url.search);
        var sanitizedSearch = sanitizeFunnelbackSearchUrl(
            url.origin + url.pathname + (cleanedSearch ? "?" + cleanedSearch : "")
        );

        try {
            url = new URL(sanitizedSearch);
        } catch (error) {
            return href;
        }

        if (isAbsolute) {
            return url.toString();
        }

        if (isQueryOnly) {
            return url.search + url.hash;
        }

        return url.pathname + url.search + url.hash;
    }

    /**
     * Repair server-rendered search links and intercept pagination navigation.
     *
     * @private
     */
    function sanitizeSearchLinksOnPage() {
        var searchRoot = document.querySelector(".qld__search");

        if (!searchRoot) {
            return;
        }

        searchRoot.querySelectorAll("a[href]").forEach(function (link) {
            var href = link.getAttribute("href");
            var sanitizedHref = sanitizeSearchHref(href);

            if (sanitizedHref !== href) {
                link.setAttribute("href", sanitizedHref);
            }
        });

        searchRoot.addEventListener("click", function (event) {
            var link = event.target.closest(".qld__search-pagination a[href]");

            if (!link) {
                return;
            }

            event.preventDefault();

            var targetHref = sanitizeSearchHref(link.getAttribute("href"));

            if (/^https?:\/\//i.test(targetHref)) {
                window.location.href = targetHref;
                return;
            }

            if (targetHref.charAt(0) === "?") {
                window.location.href = window.location.pathname + targetHref;
                return;
            }

            window.location.href = targetHref;
        });
    }

    /**
     * Submit banner search without dropping active facet filters.
     *
     * @param {HTMLFormElement} searchForm
     * @private
     */
    function initBannerSearchForm(searchForm) {
        var honeypot = searchForm.querySelector(".qld__text-input--validation");

        if (honeypot) {
            honeypot.value = "";
        }

        searchForm.addEventListener("submit", function (event) {
            if (honeypot && honeypot.value !== "") {
                event.preventDefault();
                return;
            }

            if (honeypot) {
                honeypot.removeAttribute("name");
            }

            event.preventDefault();

            var queryInput = searchForm.querySelector('[name="query"]');
            var newQuery = queryInput ? queryInput.value.trim() : "";

            window.location.href = buildSearchUrlPreservingFilters(
                newQuery,
                searchForm.getAttribute("action")
            );
        });
    }

    // Make basic search public
    QLD.basicSearch = basicSearch;

    window.addEventListener("DOMContentLoaded", function () {
        QLD.basicSearch.init();
    });
})();
